
<dashboard-card [title]="'Approvals'" [soFarAchieved]="currentOrderApproved" [dailyTarget]="minApprovalsToDone" [diffInDays]="diffInDays" [dataItems]="dataItems"></dashboard-card>